<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items.sync="data"
    :single-expand="false"
    :loading="loading"
    show-select
    show-expand
    item-key="id"
    class="elevation-1"
    hide-default-footer
  >
    <template v-slot:item.actions="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon
            medium
            v-on="on"
            @click="editGroup(item.id)"
            class="mr-2"
          >
            edit
          </v-icon>
        </template>
        <span>Grubu Adını Güncelle</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon
            medium
            v-on="on"
            @click="deleteGroup(item.id)"
            class="mr-2"
          >
            delete
          </v-icon>
        </template>
        <span>Grubu Sil</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon
            medium
            v-on="on"
            @click="exportGroup(item)"
          >
            cloud_download
          </v-icon>
        </template>

        <span>Grubu Excel'e aktarmak için tıklayınız.</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon medium v-on="on" @click="duplicates(item.id)">
            repeat
          </v-icon>
        </template>

        <span>Tekrar eden numaları kontrol et.</span>
      </v-tooltip>
    </template>
    <template v-slot:expanded-item="{ item, headers }">
      <td :colspan="headers.length" class="grey lighten-5">
        <v-card-text>
          <group-expand-datatable
            :excel-fn="exportGroup"
            :group-name="item.name"
            :id="item.id"
          >
          </group-expand-datatable>
        </v-card-text>
      </td>
    </template>
    <template v-slot:footer>
      <v-container fluid>
        <v-layout row>
          <v-flex xs6>
            <v-card-text>
              Toplam Rehber Kaydı: <b>{{ sumOfContacts }}</b>
            </v-card-text>
          </v-flex>
          <v-flex
            xs6
            class="text-right"
          >
            <v-btn
              text
              color="red"
              class="my-2 mr-1"
              @click.stop="deleteBulk"
            >
              <v-icon medium>
                delete
              </v-icon>
              Seçili Grupları Sil
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </template>
  </v-data-table>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions } from 'vuex';
import { downloadFile } from '../../../../misc';
import GroupExpandDatatable from '../GroupExpandDatatable/GroupExpandDatatable.vue';

export default {
  name: 'GroupDatatable',
  components: { GroupExpandDatatable },
  data: () => ({
    selected: [],
  }),
  props: ['headers', 'data', 'loading'],
  methods: {
    ...mapActions({
      send: 'sendBackend',
    }),
    downloadFile,
    exportGroup(group) {
      const route = 'export/group/';
      this.$http
        .get(route + group.id, {
          responseType: 'arraybuffer',
        })
        .then((res) => {
          this.downloadFile(res, group.name);
        });
    },
    editGroup(id) {
      this.modal.editedData = this.modal.data.filter(obj => obj.id === id)[0];

      this.modal.open = !this.modal.open;
      this.modal.index = 1;
    },
    deleteGroup(id) {
      console.log(id);
      this.$store.commit('fireConfirmation', () => {
        const data = { id: Array.isArray(id) ? id : [id] };
        this.send({
          route: 'delete/groups',
          data,
        }).then(() => {
          this.$trigger('delete:group', id);
        });
      });
    },
    deleteBulk() {
      if (this.selected.length > 0) {
        // Seçili olanlar obje olarak kaydedildiği için,
        // bu aşamada yanlızca id'lerini alıyorum.
        this.selected = this.selected.map(a => a.id);

        this.deleteGroup(this.selected);
      }
    },
    duplicates(id) {
      this.$router
        .push({
          name: "group.duplicates",
          params: {
            id,
          },
        });
    },
  },
  computed: {
    ...mapFields(['freeZone', 'modal']),
    sumOfContacts() {
      return this.data.map(row => row.contacts_count).reduce((a, b) => a + b, 0);
    },
  },
};
</script>
